import PetIndex from "../../components/organisms/Pet-Insurance";
const PetInsuranceIndexPage = (props) => {

  return (
    <PetIndex />
  );
};

export default PetInsuranceIndexPage;
